import React, { useState, useEffect, useCallback } from 'react';
import { fetchBookings, fetchProfessionals } from '../api';
import './Reports.css';
import AgendamentosTab from './Tabs/AgendamentosTab';

function AgendamentosReportPage() {
    const [bookings, setBookings] = useState([]);
    const [bookingsLoading, setBookingsLoading] = useState(false);
    const [professionals, setProfessionals] = useState([]);
    const [selectedProfessional, setSelectedProfessional] = useState('all');
    const [startDate, setStartDate] = useState(() => {
        const date = new Date();
        date.setDate(date.getDate() - 30); // Last 30 days default
        return date.toISOString().split('T')[0];
    });
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);

    const loadBookings = async (queryParams = {}) => {
        try {
            setBookingsLoading(true);
            
            const formattedParams = {
                ...queryParams,
                comissionStatus: 'unpaid'
            };

            if (queryParams.startDate) {
                formattedParams.startDate = `${queryParams.startDate}`;
                formattedParams.endDate = `${queryParams.endDate}`;
            }

            const bookingsData = await fetchBookings(formattedParams);
            const paidBookingsData = await fetchBookings({
                ...formattedParams,
                comissionStatus: 'sent'
            });
            
            const allBookings = [...bookingsData, ...paidBookingsData];
            setBookings(allBookings);
        } catch (error) {
            console.error('Error fetching bookings:', error);
        } finally {
            setBookingsLoading(false);
        }
    };

    const handleSearch = useCallback(() => {
        if (!startDate || !endDate) {
            alert('Por favor, selecione as datas de início e fim');
            return;
        }

        const queryParams = {
            startDate: `${startDate}`,
            endDate: `${endDate}`,
            ...(selectedProfessional !== 'all' ? { professionalId: selectedProfessional } : {})
        };

        loadBookings(queryParams);
    }, [startDate, endDate, selectedProfessional]);

    useEffect(() => {
        fetchProfessionals()
            .then(data => {
                const professionalsList = Object.entries(data.config.profissionais).map(([name, details]) => ({
                    name,
                    ...details
                }));
                setProfessionals(professionalsList);
            })
            .catch(error => console.error('Error fetching professionals:', error));
    }, []);

    useEffect(() => {
        handleSearch();
    }, [handleSearch]);

    const handleQuickFilter = (days) => {
        const end = new Date();
        const start = new Date();
        start.setDate(start.getDate() - days);
        
        const startStr = start.toISOString().split('T')[0];
        const endStr = end.toISOString().split('T')[0];
        
        setStartDate(startStr);
        setEndDate(endStr);
        
        loadBookings({
            startDate: `${startStr}`,
            endDate: `${endStr}`,
            ...(selectedProfessional !== 'all' ? { professionalId: selectedProfessional } : {})
        });
    };

    return (
        <div className="reports-container">
            <h2 style={{ marginBottom: '20px' }}>Relatório de Agendamentos</h2>
            <AgendamentosTab
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                bookingsLoading={bookingsLoading}
                bookings={bookings}
                handleSearch={handleSearch}
                handleQuickFilter={handleQuickFilter}
                setBookings={setBookings}
                professionals={professionals}
                selectedProfessional={selectedProfessional}
                setSelectedProfessional={setSelectedProfessional}
            />
        </div>
    );
}

export default AgendamentosReportPage;
